import { FC } from 'react';
import { Grid, Theme } from '@material-ui/core';
import { createStyles, makeStyles, styled } from '@material-ui/core/styles';

import {
  MarketoFormComponent,
  MarketoFormComponentProps,
} from '@bizapp-lp/workflow/organisms/MarketoFormComponent';
import {
  DocumentIntroduction,
  DocumentIntroductionProps,
} from '@bizapp-lp/workflow/organisms/DocumentIntroduction';
import { Footer } from '@bizapp-lp/workflow/organisms/Footer';
import { Header } from '@bizapp-lp/workflow/organisms/Header';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    articleArea: {
      padding: theme.spacing(5, 2, 5),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(5, 4, 7.5),
      },
    },
  }),
);

export interface ComplexMarketoFormProps
  extends Omit<DocumentIntroductionProps, 'children'>,
    MarketoFormComponentProps {
  article?: React.ReactNode;
}

export const ComplexMarketoForm: FC<ComplexMarketoFormProps> = ({
  className,
  title,
  subtitle,
  imgSrc,
  imgAlt,
  article,
  marketoForm,
  children,
}) => {
  const classes = useStyles();

  const articleProps: DocumentIntroductionProps = {
    title: title,
    subtitle: subtitle,
    imgSrc: imgSrc,
    imgAlt: imgAlt,
  };

  const FormBox = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#F2f3fb',
    padding: theme.spacing(5, 2, 7.5),
  }));

  return (
    <>
      <Header from="workflow" />
      <Grid container className={className}>
        <Grid item xs={12} sm={6} className={classes.articleArea}>
          <DocumentIntroduction {...articleProps}>
            {article}
          </DocumentIntroduction>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormBox>
            <MarketoFormComponent marketoForm={marketoForm}>
              {children}
            </MarketoFormComponent>
          </FormBox>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default ComplexMarketoForm;
